import { useMutation } from 'react-query';
import { getPrivateApi } from '../../services/api';

export function useHubspotAuthRedirect() {
  const _api = getPrivateApi();

  return useMutation(async () => {
    //const redirectResponse = await api.hubspotAuthCallback({ redirectUrl: window.location.href });
    // TODO: This is unused for now

    //window.location.href = redirectResponse.redirectUrl;
  });
}